<div class="multi-select-dropdown">
  <!-- Dropdown Toggle Button -->
  <button 
    class="dropdown-toggle"
    (click)="toggleDropdown()">
    <span class="dropdown-label">{{ getDisplayLabel() }}</span>
    <span class="dropdown-icon" [class.open]="isOpen">▼</span>
  </button>

  <!-- Dropdown Menu -->
  <div class="dropdown-menu" *ngIf="isOpen">
    <!-- "All items" option (always at top) -->
    <div class="dropdown-option all-option" (click)="selectedIds = []; selectionChange.emit([])">
      <input 
        type="checkbox" 
        class="option-checkbox"
        [checked]="selectedIds.length === 0"
        (change)="selectedIds = []; selectionChange.emit([])"
      />
      <span class="option-label">{{ icon }} All items</span>
    </div>

    <!-- Divider -->
    <div class="dropdown-divider"></div>

    <!-- Individual options -->
    <div 
      *ngFor="let option of options" 
      class="dropdown-option"
      (click)="toggleOption(option.id)">
      <input 
        type="checkbox" 
        class="option-checkbox"
        [checked]="isSelected(option.id)"
        (change)="toggleOption(option.id)"
      />
      <span class="option-label">{{ option.label }}</span>
    </div>
  </div>

  <!-- Backdrop (click outside to close) -->
  <div 
    class="dropdown-backdrop" 
    *ngIf="isOpen"
    (click)="closeDropdown()">
  </div>
</div>
